export default "__VITE_ASSET__9a1a528e__"